import { formatTimer } from '../../utils/callUtils.js'

/**
 * Composable pour le formatage des données d'appel
 */
export function useCallFormatting() {
  const formatCallNotes = (comments, duration) => {
    let notes = comments ? comments.trim() : ''
    if (notes) {
      notes += '\n\n' + `Durée de l'appel : ${formatTimer(duration)}`
    } else {
      notes = `Durée de l'appel : ${formatTimer(duration)}`
    }
    return notes || null
  }

  return {
    formatCallNotes
  }
}
